import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import { Link, useNavigate } from "react-router-dom";
import Toastmessage from "../../components/Toast";
import { logout } from "../../features/auth/AuthSlice";
import { authApi } from "../../api/api";
import { useDispatch, useSelector } from "react-redux";
import { FormControl } from "@mui/material";

const columns = [
  {
    field: 'month', headerName: 'Month/Year', flex: 1, renderCell: (params) => (
      <span style={{ fontWeight: 'bold', color: 'var(--primary-color)' }}>{params.value}</span>
    ),
  },
  { field: 'billableDollars', headerName: 'Billable Dollars', flex: 1 },
  { field: 'targetBillableDollars', headerName: 'Target Billable Dollars', flex: 1 },
  { field: 'overUnder', headerName: 'Over / Under', flex: 1 },
  { field: 'percentComplete', headerName: 'Percent Complete', flex: 1 },
];


const locations = ['GA', 'NY', 'CA'];
const years = ['2024', '2023', '2022'];

export default function ProductionSummary() {


  const [rows, setRows] = useState([]);

  const [locationOption, setLocationOptions] = useState([]);
  const [locationName, setLocationName] = useState(null);
  const [monthYear, setMonthYear] = useState('');
  const [monthYearOption, setMonthYearOption] = useState([]);

  const dispatch = useDispatch()
  const navigate = useNavigate();

  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux


  useEffect(() => {
    fetctSummary();
    fetchLocation()
    fetcYearMonth()
  }, []);

  const handleLocationChange = (event, newValue) => {
    setLocationName(newValue);
  };

  const handleMonthYearChange = (event, newValue) => {
    setMonthYear(newValue);
  };

  // Define fetchLocations separately to reuse it
  const fetcYearMonth = async () => {
    const input_token = 'TIMESHEET_MONTH_YEAR'; // Replace with your actual token
    const apiUrl = 'get_month_year'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        setMonthYearOption(data?.year);
        setMonthYear(data?.year?.[0])
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };



  // Define fetchLocations separately to reuse it
  const fetchLocation = async () => {
    const input_token = 'LOCATIONS'; // Replace with your actual token
    const apiUrl = 'list_of_locations'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        const statesArray = data.locations.map(location => ({
          id: location.id,
          locationname: location.location_name, // Match `getOptionLabel`
        }));
        statesArray.unshift({ id: "All", locationname: 'All' });
        setLocationOptions(statesArray);
        setLocationName(statesArray[0]);

      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };


  // Define fetchLocations separately to reuse it
  const fetctSummary = async () => {
    const input_token = 'PRODUCTION_SUMMARY'; // Replace with your actual token
    const apiUrl = 'production_summary'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID,
      "location": 11,
      "year": "2024",

    };
    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);
      if (data && data.success) {
        setRows(data?.weekly_report)
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };


  return (
    <Box sx={{ width: '100%', padding: 2, }}>
      <Box sx={{ width: '100%', padding: 2, backgroundColor: 'var(--theme-bg-light)', borderRadius: 2, }}>
        <Typography variant="h5" sx={{ marginBottom: 2, fontWeight: 'bold' }}>
          Production Summary
        </Typography>


        <Grid container spacing={2} sx={{ marginBottom: 2 }} alignItems={"end"}>
          <Grid item size={{md: 2, xs: 6 }}>
            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Location</Typography>
            <FormControl fullWidth>
              <Autocomplete
                options={locationOption}
                getOptionLabel={(option) => option.locationname}
                value={locationName}
                onChange={handleLocationChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select location"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      sx: { borderRadius: '8px', backgroundColor: 'var(--theme-bg-light)' },
                    }}
                  />
                )}
                sx={{ width: '100%' }}
              />
            </FormControl>
          </Grid>
          <Grid item size={{md: 2, xs: 6 }}>
            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Month & Year</Typography>
            <FormControl fullWidth>
              <Autocomplete
                options={monthYearOption}
                value={monthYear}
                onChange={handleMonthYearChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select month & year"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      sx: { borderRadius: '8px', backgroundColor: 'var(--theme-bg-light)' },
                    }}
                  />
                )}
                sx={{ width: '100%' }}
              />
            </FormControl>
          </Grid>
          {/* <Grid item size={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" sx={{ padding: '15px 30px', borderRadius: "8px", backgroundColor: 'var(--primary-color)', color: '#fff', '&:hover': { backgroundColor: 'var(--primary-color)' } }}>Export Reports</Button>
          </Grid> */}
        </Grid>
        <DataGrid
          rows={rows}
          columns={columns}
          className="data-grid"
          hideFooter
          disableSelectionOnClick
        />
      </Box>
    </Box >
  );
}
